var render = function (_h,_vm) {var _c=_vm._c;return _c('svg',{staticClass:"fill-current",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}},[_c('path',{attrs:{"d":"M18.59 13H3a1 1 0 0 1 0-2h15.59l-5.3-5.3a1 1 0 1 1 1.42-1.4l7 7a1 1 0 0 1 0 1.4l-7 7a1 1 0 0 1-1.42-1.4l5.3-5.3z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }